import { Button, Grid, Paper } from '@mui/material';
import { withStyles } from 'utils/styles';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import reachOKLogo from 'images/brand/REACHok_branco.png';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles';

const Component = props => {
  const { classes } = props;

  return (
    <div className={classes.container}>
      <div className={classes.loginArea}>
        <Paper className={classes.paper}>
          <div className={classes.margin}>

            <Grid sx={{ justifyContent: 'center' }} container>
              <Grid size={8}>
                <img src={reachOKLogo} style={{ width: '100%' }} alt=""/>
              </Grid>
            </Grid>

            <Divider style={{ marginBottom: '15px' }}/>

            <Grid sx={{ justifyContent: 'center' }} container spacing={8}>
              <Grid size={10}>
                <Typography variant="h6" align='center' gutterBottom>
                  Session Logged Out !
                </Typography>
                <Typography variant="body2" align='justify' gutterBottom>
                  Your session was logged out by yourself, or because some issue with authentication was detected
                </Typography>
              </Grid>
            </Grid>

            <Divider style={{ marginTop: '15px', marginBottom: '30px' }}/>


            <Grid sx={{ justifyContent: 'center' }} container style={{ marginTop: '30px' }}>
              <Button
                type="submit"
                className={classes.textTransformationNone}
                variant="contained"
                color="secondary"
              >
                Go to Login Page
              </Button>
            </Grid>

          </div>
        </Paper>
      </div>
    </div>
  );
};

Component.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Component);
